import AbstractView from 'abstract';
import Vue from 'vue'
import SettingsInit from 'initializations/pages/Pax/ProfileSettings'
import PinsInit from 'initializations/pages/Pax/Pins'
import SidebarInit from 'initializations/Sidebar'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
      SidebarInit.init("sidebar")
      SettingsInit.init("profileSettings")
      PinsInit.init("pins")

      const ProfileSettings = () => import(/* webpackChunkName: "settings-page" */ 'containers/Pages/Profile/Settings')
      new Vue({
        el: "#" + this.elemId,
        store,
        render: h => h(ProfileSettings)
      })
    }
}
